import React, { useEffect, useState } from "react";
// import styles from "./ViewPurchase.module.css";
import ViewPurchaseInfo from "../../../BookModule.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { R_PER_PAGE } from "../../../../../../../labels";
import CourierDetails from "../../../CourierDetails";
import ViewIcon from "../ViewIcon.png";
import { IconButton, styled, Tooltip } from "@mui/material";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../../../../axios";
import Loader from "../../../../../Loader";
import moment from "moment";
import PickUpDetails from "../../../PickUpDetails";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function ViewPurchase() {
  const navigate = useNavigate();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  //   const { user, logout } = UserContext(UserContext);
  let page = R_PER_PAGE;

  //   -----Table variables
  const { id } = useParams();


  // ---------------
  const location = useLocation();
  const {
    PAYMENT_MODE,
    DELIVERY_MODE,
    BRANCH_LOCATION,
    BATCH_NAME,
    DELIVERY_STATUS,
    ENROLL_STUDENT,
    SEARCH_TERM,
    DATE,
  } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy");
  const [rowsPerPage, setRowsPerPage] = useState(page); //1
  const [currentPage, setCurrentPage] = useState(1); //1
  const [rowsPerPages, setRowsPerPages] = useState(page); //1
  const [currentPages, setCurrentPages] = useState(1); //1
  const [sortOrder, setSortOrder] = useState("asc"); //1
  const [sortOrders, setSortOrders] = useState("asc"); //2
  const [updateListData, setUpdateListData] = useState();
  const [preOrderData, setPreOrderData] = useState();

  const [courierDetails, setCourierDetails] = useState();
  const [listdata, setListData] = useState();
  const [initialfields, setInitialFields] = useState({
    purchase_id: "",
    userName: "",
    email_id: "",
    phoneNumber: "",
    enrolledStudent: "",
    date: "",
    amountPaid: "",
    paymentMode: "",
    deliveryMode: "",
    deliveryStatus: "",
    delivery_status_number: "",
    expectedDeliveryDate: "",
    deliveryMethod: "",
    deliveryMethodStatus: "",
    deliveryAddress: "",
    delivery_status: "", //value integer
    created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
    created_by: userid,
    batch_name: "",
  });

  // 1
  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);
  // 2
  useEffect(() => {
    setPreOrderData(preOrderData);
  }, [preOrderData]);
  useEffect(() => {
    loadListdata();
  }, []);

  function loadListdata() {
    setIsLoading(true);
    const payload = { id: parseInt(id) };
    AxiosInstance.post("/api/book/purchase/view", payload)
      .then((res) => {
        if (res?.data?.status) {
          setIsLoading(false);
          const data = res?.data?.data[0];
          const delivery = res?.data?.delivery_address[0];
          setListData(delivery);
          const purchased = res?.data?.books_purchased.flat();
          const preOrderBook = res?.data?.pre_order_books.flat();
          const serialNumberAddedData = purchased.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
          setUpdateListData(purchased);
          setCourierDetails(res.data.courier_details);
          const serialNumberAddedDataPre = purchased.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setPreOrderData(serialNumberAddedDataPre);
          setPreOrderData(preOrderBook);
          // const expectedDeliveryDate = moment(data.date)
          //   .add(7, "days") // Add 7 days or any required duration
          //   .format("DD/MM/YYYY");
          setInitialFields({
            batch_name: data.batch_name ? data.batch_name : "",
            purchase_id: data.purchase_id,
            userName: data.username,
            email_id: data.email,
            phoneNumber: data.phone_no,
            enrolledStudent: data.enrolled_student,
            date:
              data.date && moment.utc(data.date).isValid()
                ? moment.utc(data.date).format("DD/MM/YYYY")
                : "_", // Format date using moment
            amountPaid: data.total_amount,
            paymentMode:
              data.payment_mode === 1
                ? "Online"
                : data.payment_mode === 2
                ? "QR Cash"
                : data.payment_mode === 3
                ? "Free"
                : "Cash",
            deliveryMode: data.delivery_mode,
            delivery_status: data.delivery_status,
            delivery_status_number: data.delivery_status_number,
            deliveryStatus:
              data.delivery_status === 0
                ? "Pickup Pending"
                : data.delivery_status === 1
                ? "Shipping in Progress"
                : data.delivery_status === 2
                ? "Delivered"
                : "-",
            deliveryMethod:
              data.delivery_mode == 0 ? "Branch Pickup" : "Courier Delivery", // Static example
            deliveryMethodStatus: data.delivery_mode,
            // deliveryAddress: `${delivery.name}, ${delivery.address},  - ${delivery.pincode}, Ph : ${delivery.phone_no} `,
            deliveryAddress:
              data.delivery_mode == 0
                ? `${delivery.address}, ${delivery.city} - ${delivery.pincode}, Ph : ${delivery.phone_no} `
                : `${delivery.name}, ${delivery.address},  - ${delivery.pincode}, Ph : ${delivery.phone_no} `,
            expectedDeliveryDate: moment(data.date).format("DD/MM/YYYY"),
          });
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setPreOrderData([]);
        setIsLoading(false);
        return error;
      });
  }

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);
  const totalPagess = Math.ceil(preOrderData?.length / rowsPerPages);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePrevs = (val) => {
    setCurrentPages(val);
  };
  // next button pagination
  const handleNexts = (val) => {
    setCurrentPages(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };

  const handlePageCounts = (e) => {
    setRowsPerPages(Number(e.target.value));
    setCurrentPages(1);
    setPreOrderData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;

  const starts = (currentPages - 1) * rowsPerPages;
  const ends = starts + rowsPerPages;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);
  const currentDatas = preOrderData?.slice(starts, ends);

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };
  const handleSorts = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrders === "asc" ? "desc" : "asc";
    setSortOrders(order);
    let sortedList = preOrderData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setPreOrderData(sortedList);
  };
  //   --------------------------------
  const handleBackFilter = () => {
    navigate(`/ListPurchase`, {
      state: {
        paymentMode: PAYMENT_MODE,
        deliveryMode: DELIVERY_MODE,
        enrolledStudent: ENROLL_STUDENT,
        BranchLocation: BRANCH_LOCATION,
        batchName: BATCH_NAME,
        deliveryStatus: DELIVERY_STATUS,
        fillSearch: SEARCH_TERM,
        filter_date: DATE,
      },
    });
  };
  const [showData, setShowData] = useState([]);

  useEffect(() => {
    const allEbooks =
      currentData?.length > 0 &&
      currentData.every((item) => item.is_ebook === 1);
    setShowData(allEbooks);
  }, [updateListData]);

  const handleViewBOOK = (IDS, bookId, type) => {
    if (type == 1) {
      navigate(`/studyMaterials/Books/ViewBookSet/${bookId}/${IDS}`, {
        state: {
          LABEL: "Back to View Sales",
            IDS:id
        },
      });
    } else {
      navigate(`/viewIndividualBook/${IDS}`, {
        state: {
          LABEL: "Back to View Sales",
        
        },
      });
    }
  };

  const handleClick = (id, is_ebook) => {
    if (is_ebook == 0) {
      navigate(`/viewIndividualBook/${id}`);
    } else if (is_ebook == 1) {
      navigate(`/viewIndividualBook/${id}`);
    }
  };

  const handleCopy = () => {
    const textToCopy = `${initialfields.userName || "_"}, ${
      initialfields.purchase_id || "_"
    }, ${initialfields.deliveryAddress || "_"}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setTooltipText("Copied");
        setTimeout(() => {
          setTooltipText("Copy");
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={` BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">View Sales</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                onClick={() => handleBackFilter()}
                to="javascript:void(0)"
                className="secondaryButton "
                variant="secondary"
              >
                Back to Sales
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* Fieldset 1 */}
      <div className="mb-4">
        <fieldset className="mt-3">
          <legend className="w-auto">Sales Details</legend>
          <div className="row mb-3">
            {/* row 1 */}
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0">Order ID</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields?.purchase_id}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> User Name</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields?.userName || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Email ID</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.email_id || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Phone Number</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.phoneNumber || "_"}
                </p>
              </div>
            </div>
            {/* row 2 */}
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Enrolled Student</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.enrolledStudent == 1 ? "Yes" : "No" || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Date</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.date || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Amount Paid</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.amountPaid || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Payment Mode</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.paymentMode || "_"}
                </p>
              </div>
            </div>
            {/* row 3 */}
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Delivery Mode</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.deliveryMode === 1
                    ? "Courier Delivery"
                    : "Branch Pickup" || "_"}
                </p>
              </div>
            </div>

            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Delivery Status</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.delivery_status || "_"}
                </p>
              </div>
            </div>
            {initialfields.delivery_status !== 2 && (
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    {initialfields.deliveryMode === 1
                      ? "Expected Delivery Date"
                      : "Expected Pickup Date"}{" "}
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {initialfields.expectedDeliveryDate
                      ? moment(initialfields.expectedDeliveryDate, "DD/MM/YYYY")
                          .add(7, "days")
                          .format("DD/MM/YYYY")
                      : "_"}
                  </p>
                </div>
              </div>
            )}
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0">{"Batch Name"}</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.batch_name ? initialfields.batch_name : "_"}
                </p>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      {/* Fieldset 2 */}

      {!showData && (
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">
              {initialfields.deliveryMethodStatus == 1
                ? "Delivery Address"
                : "Pickup Address"}
            </legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Delivery Mode</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {initialfields.deliveryMethod || "_"}
                  </p>
                </div>
              </div>

              <div className="my-1 col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    {initialfields.deliveryMethodStatus == 1
                      ? "Delivery Address"
                      : "Pickup Address"}{" "}
                  </p>
                  <div className="d-flex flex-row">
                    <p className="confirm_value my-1 m-0 p-0">
                      {initialfields.userName || "_"},{" "}
                      {initialfields.purchase_id || "_"},{" "}
                      {initialfields.deliveryAddress || "_"}
                    </p>
                    <Tooltip title={tooltipText} arrow>
                      <IconButton
                        onClick={handleCopy}
                        style={{
                          marginLeft: "8px",
                          color: "white",
                          background: "#c1393d",
                        }}
                      >
                        <ContentCopyIcon style={{ fontSize: "20px" }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      )}

      {/* Fieldset 3 */}
      {initialfields.deliveryMode === 1 && (
        <CourierDetails
          couItem={courierDetails}
          disableStatus={initialfields.delivery_status_number != 0}
          bookPur={currentData}
          idPur={id}
          addressData={listdata}
        />
      )}
      {currentData?.length > 0 &&
        currentData.some((item) => item.is_ebook === 0) &&
        initialfields.deliveryMode === 0 && (
          <PickUpDetails
            PicUpItem={courierDetails}
            bookPur={currentData}
            disableStatus={initialfields.delivery_status_number != 0}
            idPur={id}
          />
        )}

      {/* FieldSet - 4 (Book Purchased) */}
      <div className="mb-4">
        <fieldset className="mt-3">
          <legend className="w-auto">Books Purchased</legend>
          {/* Table Header */}
          <div className="row mx-0 mt-2">
            <div
              className={`col-md-12 ${ViewPurchaseInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
            >
              <table className="table" id="tableListHeader">
                <thead>
                  <tr>
                    {/* S.No */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "serialNumber")}
                        className="textHead_th"
                      >
                        S.No.
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "serialNumber")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Book name */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "book_name")}
                        className="textHead_th"
                      >
                        Book Name
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "book_name")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Author */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "author")}
                        className="textHead_th"
                      >
                        Author
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "author")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Publisher */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <div class={ViewPurchaseInfo.thcontent}>
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          class="textHead_th"
                        >
                          Publisher
                        </span>
                        <div class={ViewPurchaseInfo.iconcontainer}>
                          <span
                            onClick={(e) => handleSort(e, "publisher")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </div>
                    </th>
                    {/* No of books */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <div class={ViewPurchaseInfo.thcontent}>
                        <span
                          onClick={(e) => handleSort(e, "totalBooksCount")}
                          class="textHead_th"
                        >
                          Quantity
                        </span>
                        <div class={ViewPurchaseInfo.iconcontainer}>
                          <span
                            onClick={(e) => handleSort(e, "totalBooksCount")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </div>
                    </th>
                    {/* Category */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "category_name")}
                        className="textHead_th"
                      >
                        Category
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "category_name")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Course */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "group_course_name")}
                        className="textHead_th"
                      >
                        Course
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "group_course_name")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Subject */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "subject_name")}
                        className="textHead_th"
                      >
                        Subject
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "subject_name")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Medium */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "medium")}
                        className="textHead_th"
                      >
                        Medium
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "medium")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Book Series */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "series_name")}
                        className="textHead_th"
                      >
                        Book Series
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "series_name")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* MRP */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className="textHead_th"
                      >
                        MRP
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Offer Precentage */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className="textHead_th"
                      >
                        Offer Percentage
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Final Price */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className="textHead_th"
                      >
                        Final Price
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "price")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>

                    {/* individual and Bookset */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <div class={ViewPurchaseInfo.thcontent}>
                        <span
                          onClick={(e) => handleSort(e, "individualBookset")}
                          class="textHead_th"
                        >
                          Individual /<br /> Bookset
                        </span>

                        <div class={ViewPurchaseInfo.iconcontainer}>
                          <span
                            onClick={(e) => handleSort(e, "individualBookset")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </div>
                    </th>
                    {/* Delivery Status */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "deliveryStatus")}
                      >
                        Delivery Status
                      </span>
                      <span
                        onClick={(e) => handleSort(e, "deliveryStatus")}
                        className={`textHead_th material-icons align-middle`}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    {/* Action */}
                    <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                      <span className="textHead_th">Action</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.length === 0 ? (
                    <tr>
                      <td colspan="15" style={{ textAlign: "center" }}>
                        No records to display
                      </td>
                    </tr>
                  ) : (
                    currentData?.map((kl, ind) => (
                      <tr key={ind}>
                        <td id="td">{kl.serialNumber || ind + 1}</td>
                        <td id="td">
                          <span
                            title={kl.book_title}
                            className={ViewPurchaseInfo.ellipsisText}
                          >
                            {kl.book_title ? kl.book_title : "_"}
                          </span>
                        </td>
                        <td id="td">{kl.author ? kl.author : "_"}</td>
                        <td id="td">{kl.publisher ? kl.publisher : "_"}</td>
                        <td id="td">{kl.no_of_books ? kl.no_of_books : "_"}</td>
                        <td id="td">
                          {kl.category_name ? kl.category_name : "_"}
                        </td>
                        <td id="td">
                          {kl.group_course_name ? kl.group_course_name : "_"}
                        </td>
                        <td id="td">
                          <span
                            title={kl.subject_name}
                            className={ViewPurchaseInfo.ellipsisText}
                          >
                            {kl.subject_name || "_"}
                          </span>
                        </td>
                        <td id="td">{kl.medium ? kl.medium : "_"}</td>
                        <td id="td">{kl.series_name ? kl.series_name : "_"}</td>
                        <td id="td">{kl.price ? kl.price : "0"}</td>
                        <td id="td">
                          {kl.offer_percentage ? kl.offer_percentage : "0"}
                        </td>
                        <td id="td">{kl.finalPrice ? kl.finalPrice : "0"}</td>

                        <td id="td">
                          {" "}
                          {kl.is_set === 0
                            ? "Individual"
                            : kl.is_set === 1
                            ? "Bookset"
                            : "_"}
                        </td>
                        <td id="td">
                          {kl.delivery_status_name
                            ? kl.delivery_status_name
                            : "_"}{" "}
                          {kl.is_set === 1 &&
                            kl.Pending_count > 0 &&
                            `(${kl.Pending_count})`}
                        </td>
                        {/* <td id="td">
                          {kl.delivery_status === 0 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusPink}`}
                              >
                                Pickup Pending{" "}
                                {kl.is_set === 1 && `(${kl.Pending_count})`}
                              </span>
                            </>
                          ) : kl.delivery_status === 1 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusYellow}`}
                              >
                                Shipping in Progress
                              </span>{" "}
                            </>
                          ) : kl.delivery_status === 2 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusGreen}`}
                              >
                                Delivered
                              </span>
                            </>
                          ) : (
                            "_"
                          )}
                        </td> */}
                        <td id="td">
                          <img
                            onClick={() =>
                              handleViewBOOK(kl.id, kl.book_ids, kl.is_set)
                            }
                            src={ViewIcon}
                            className={ViewPurchaseInfo.cursor_pointer}
                            alt="view icon"
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagnatiion */}
          <div className="row mt-2">
            <Pagination
              rowsPerPage={rowsPerPage}
              handlePageCount={handlePageCount}
              startPage={
                currentData && currentData?.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0
              }
              endPage={
                currentData && currentData?.length > 0
                  ? currentData?.length < currentPage * rowsPerPage
                    ? currentData?.length
                    : currentPage * rowsPerPage
                  : 0
              }
              totalRecords={
                currentData && currentData?.length > 0 ? currentData?.length : 0
              }
              handlePrev={(e) => handlePrev(currentPage - 1)}
              currentPrevPage={currentPage === 1}
              prevButton={`${ViewPurchaseInfo.prev_buttonViewAllbook} ${ViewPurchaseInfo.materialIconsRightAndLeft} me-2`}
              handleNext={() => handleNext(currentPage + 1)}
              currentNextPage={currentPage === totalPages || totalPages == 0}
            />
          </div>
        </fieldset>
      </div>
      {preOrderData?.length > 0 && (
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Pre-order Books</legend>
            {/* Table Header */}
            <div className="row mx-0 mt-2">
              <div
                className={`col-md-12 ${ViewPurchaseInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
              >
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      {/* S.No */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Book name */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "book_name")}
                          className="textHead_th"
                        >
                          Book Name
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "book_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Author */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "author")}
                          className="textHead_th"
                        >
                          Author
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "author")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Publisher */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <div class={ViewPurchaseInfo.thcontent}>
                          <span
                            onClick={(e) => handleSorts(e, "publisher")}
                            class="textHead_th"
                          >
                            Publisher
                          </span>
                          <div class={ViewPurchaseInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSorts(e, "publisher")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>
                      {/* No of books */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <div class={ViewPurchaseInfo.thcontent}>
                          <span
                            onClick={(e) => handleSorts(e, "no_of_books")}
                            class="textHead_th"
                          >
                            Quantity
                          </span>
                          <div class={ViewPurchaseInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSorts(e, "no_of_books")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>
                      {/* Bookset */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <div class={ViewPurchaseInfo.thcontent}>
                          <span
                            onClick={(e) => handleSorts(e, "bookset_name")}
                            class="textHead_th"
                          >
                            Bookset Name
                          </span>
                          <div class={ViewPurchaseInfo.iconcontainer}>
                            <span
                              onClick={(e) => handleSorts(e, "bookset_name")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>
                      {/* Category */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Course */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "group_course_name")}
                          className="textHead_th"
                        >
                          Course
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "group_course_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Subject */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "subject_name")}
                          className="textHead_th"
                        >
                          Subject
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "subject_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Medium */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Expected DeliveryDate */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSorts(e, "expected_date")}
                          className="textHead_th"
                        >
                          Expected <br /> DeliveryDate
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "expected_date")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Delivery Status */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => handleSorts(e, "delivery_status")}
                        >
                          Delivery Status
                        </span>
                        <span
                          onClick={(e) => handleSorts(e, "delivery_status")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Action */}
                      <th id="th" className={ViewPurchaseInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentDatas?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentDatas?.map((kl, ind) => (
                        <tr key={ind}>
                          <td id="td">{kl.serialNumber || ind + 1}</td>
                          <td id="td">
                            <span
                              title={kl.book_title}
                              className={ViewPurchaseInfo.ellipsisText}
                            >
                              {kl.book_title ? kl.book_title : "_"}
                            </span>
                          </td>
                          <td id="td">{kl.author ? kl.author : "_"}</td>
                          <td id="td">{kl.publisher ? kl.publisher : "_"}</td>
                          <td id="td">
                            {kl.no_of_books ? kl.no_of_books : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={kl.bookset_name}
                              className={ViewPurchaseInfo.ellipsisText}
                            >
                              {kl.bookset_name ? kl.bookset_name : "_"}
                            </span>
                          </td>
                          <td id="td">
                            {kl.category_name ? kl.category_name : "_"}
                          </td>
                          <td id="td">
                            {kl.group_course_name ? kl.group_course_name : "_"}
                          </td>
                          <td id="td">
                            {kl.subject_name ? kl.subject_name : "_"}
                          </td>
                          <td id="td">{kl.medium ? kl.medium : "_"}</td>
                          <td id="td">
                            {kl.expected_date
                              ? moment(kl.expected_date).format("DD/MM/YYYY")
                              : "_"}
                          </td>
                          {/* <td id="td">
                          {kl.delivery_status === 0 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusPink}`}
                              >
                                Pickup Pending
                              </span>
                            </>
                          ) : kl.delivery_status === 1 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusYellow}`}
                              >
                                Shipping in Progress
                              </span>{" "}
                            </>
                          ) : kl.delivery_status === 2 ? (
                            <>
                              <span
                                className={`${ViewPurchaseInfo.deliveryStatus} ${ViewPurchaseInfo.deliveryStatusGreen}`}
                              >
                                Delivered
                              </span>
                            </>
                          ) : (
                            "_"
                          )}
                        </td> */}
                          <td id="td">
                            {kl.delivery_status ? kl.delivery_status : "_"}
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={ViewPurchaseInfo.cursor_pointer}
                              alt="view icon"
                              onClick={() => handleClick(kl.id, kl.is_ebook)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagnatiion */}
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPages}
                handlePageCount={handlePageCounts}
                startPage={
                  preOrderData && preOrderData?.length > 0
                    ? currentPages * rowsPerPages + 1 - rowsPerPages
                    : 0
                }
                endPage={
                  preOrderData && preOrderData?.length > 0
                    ? preOrderData?.length < currentPages * rowsPerPages
                      ? preOrderData?.length
                      : currentPages * rowsPerPages
                    : 0
                }
                totalRecords={
                  preOrderData && preOrderData?.length > 0
                    ? preOrderData?.length
                    : 0
                }
                handlePrev={(e) => handlePrevs(currentPages - 1)}
                currentPrevPage={currentPages === 1}
                prevButton={`${ViewPurchaseInfo.prev_buttonViewAllbook} ${ViewPurchaseInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNexts(currentPages + 1)}
                currentNextPage={
                  totalPagess == 0 || currentPages === totalPagess
                }
              />
            </div>
          </fieldset>
        </div>
      )}
      {/* Fieldset - 5 (Pre-order Books) */}
    </div>
  );
}

export default ViewPurchase;
